<div class="tab-view">
  <div class="tab-head pointer-cursor" *ngFor="let tab of tabs, let i = index"
       [ngClass]="{active: tab === currentTab}" (click)="openTab(tab)">
      <div class="tab-head-name tooltip-head" [ngStyle]="{'max-width': dynamicTabs ? '151px' : 'fit-content'}">
        <span>{{tab.includes(':') ? tab.split(' : ')[0] : tab.split('?')[0] | uppercase}}</span>
        <div class="tooltip-text" *ngIf="dynamicTabs">{{tab.split('?')[0] | uppercase}}</div>
      </div>
      <span class="close-icon" *ngIf="dynamicTabs && (!reservedTabNames.includes(tab))" (click)="closeTab(tab)">&#x2715;</span>
  </div>
</div>
